import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyEditPortfolio = lazy(() => import('./EditPortfolio.tsx'));

export const EditPortfolio: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyEditPortfolio {...props} />
	</Suspense>
);
